export const isActionBusy = (...flags: Array<boolean | undefined | null>) => flags.some(Boolean);
